import React, { useCallback, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { previewPages } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function InsidePreview() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const total = previewPages.length;
  const go = useCallback((nextIndex: number, dir: number) => {
    setDirection(dir);
    setIndex((nextIndex + total) % total);
  }, [total]);
  const current = previewPages[index];
  return <section id="inside-look" className="w-full bg-ink px-5 py-20 sm:py-28" aria-roledescription="carousel" aria-label="Sample pages from inside the material" onKeyDown={event => {
    if (event.key === 'ArrowRight') go(index + 1, 1);
    if (event.key === 'ArrowLeft') go(index - 1, -1);
  }} data-id="element-118" data-mp="3585ur2ukj25z">
      <div className="mx-auto max-w-3xl text-center" data-id="element-119" data-mp="3swf7lf9t0fkz">
        <h2 className="font-display text-[1.75rem] font-black leading-tight tracking-tight text-cream sm:text-[2.4rem]" data-id="element-120" data-mp="3lp9vug2e1n32">
          See the Material From the Inside
        </h2>
        <p className="mt-3 text-sm text-cream/55" data-id="element-121" data-mp="3bzzyakorzc7k">
          A few sample pages from inside the six volumes.
        </p>
      </div>

      <div className="relative mx-auto mt-10 flex max-w-5xl items-center gap-3 sm:gap-6" data-id="element-122" data-mp="3gxid2rph4lnh">
        <button type="button" onClick={() => go(index - 1, -1)} aria-label="Previous page" className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-cream text-ink shadow-soft transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-white focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40" data-id="element-123" data-mp="32xz4jxsr38an">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-124" data-mp="ra0ywzlsqbgk" />
        </button>

        <div className="relative mx-auto aspect-[4/5] w-full max-w-[700px] overflow-hidden rounded-2xl bg-white ring-1 ring-white/10" data-id="element-125" data-mp="w79hh1auwhic">
          <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-126" data-mp="up2eih8zm40j">
            <motion.img key={current.image} src={current.image} alt={`${current.title} — sample page`} custom={direction} initial={{
            opacity: 0,
            x: direction * 40
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: direction * -40
          }} transition={{
            duration: 0.26,
            ease: EASE
          }} className="absolute inset-0 h-full w-full object-contain" draggable={false} data-id="element-127" data-mp="pr0unu3qm0o0" />
          </AnimatePresence>
        </div>

        <button type="button" onClick={() => go(index + 1, 1)} aria-label="Next page" className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-brand-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40" data-id="element-128" data-mp="ytju048bdv5i">
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-129" data-mp="23sowwlr5xyjp" />
        </button>
      </div>

      <p className="mt-6 text-center text-xs font-bold uppercase tracking-[0.16em] text-cream/60" aria-live="polite" data-id="element-130" data-mp="28q8kwddnxpou">
        {current.title}
        <span className="ml-2 tabular-nums text-cream/35" data-id="element-131" data-mp="2ippomp9ctti6">
          {index + 1}/{total}
        </span>
      </p>

      <ul className="mt-6 flex flex-wrap items-center justify-center gap-3" data-id="element-132" data-mp="2mpzs9v9oc7tv">
        {previewPages.map((page, pageIndex) => {
        const isActive = pageIndex === index;
        return <li key={page.image} data-id="element-133" data-mp="2wgug342kjfhf" data-mpi={pageIndex}>
              <button type="button" onClick={() => go(pageIndex, pageIndex > index ? 1 : -1)} aria-label={`Show ${page.title}`} aria-current={isActive} className={`block h-16 w-12 overflow-hidden rounded-md transition-[transform,opacity] duration-150 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 ${isActive ? 'opacity-100 ring-2 ring-brand' : 'opacity-50 ring-1 ring-white/15 hover:opacity-90'}`} data-id="element-134" data-mp="2wg2sogj4ko28">
                <img src={page.image} alt="" className="h-full w-full object-cover" data-id="element-135" data-mp="btu7aebctxm4" />
              </button>
            </li>;
      })}
      </ul>
    </section>;
}